import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { ILoginStep1Response } from '../../../entity/interface/iLoginEntities';

export interface ILoginStep1UseCase {
    execute(username: string, agent: string): Promise<ILoginStep1Response>;
}

export class LoginStep1UseCase implements ILoginStep1UseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(username: string, agent: string): Promise<ILoginStep1Response> {
        return await this.userRepo.loginStep1(username, agent);
    }
}
